export const firebaseConfig = {
  apiKey: 'AIzaSyAn-_ZpDtisqL46wOzpwfwKgkYCCPAtQe8',
  authDomain: 'trava-ai-np.firebaseapp.com',
  databaseURL: 'https://trava-ai-np.firebaseio.com',
  projectId: 'trava-ai-np',
  storageBucket: '',
  messagingSenderId: '872616575997',
  appId: '1:872616575997:web:6f4d45e63aac7b47'
}